import ErrorCode from '../enums/ErrorCode';

export class ErrorCodeUtils {

  // return the error message based of the errorCodeEnum
  static getErrorMessage(errorCode: number): string {
    switch (errorCode) {
      case ErrorCode.NO_ERROR:
      case ErrorCode.ATTRIBUTE_NOT_IN_CLASS:
      case ErrorCode.COMPONENT_IS_NOT_UNIQUE:
      case ErrorCode.MATERIAL_NOT_IN_CLASS:
      case ErrorCode.GROUP_RELEVANT_CHANGE:
      case ErrorCode.COMPONENT_NOT_FOUND:
      case ErrorCode.PARENT_INVALID_OBJECT_STATE:
      case ErrorCode.IMPORT_FILE_SAME_CHECKSUM:
      case ErrorCode.IMPORT_FILE_INVALID:
      case ErrorCode.LOCATION_ALREADY_EXIST:
        return null;
      case ErrorCode.PRODUCER_USED_IN_CLASS:
        return "MESSAGE_TEXTS.ERROR_MSG.PRODUCER_USED_IN_CLASS";
      case ErrorCode.PRODUCER_USED_IN_OBJECT:
        return "MESSAGE_TEXTS.ERROR_MSG.PRODUCER_USED_IN_OBJECT";
      case ErrorCode.PRODUCER_USED_IN_MODULE_ATTRIBUTE:
        return "MESSAGE_TEXTS.ERROR_MSG.PRODUCER_USED_IN_MODULE_ATTRIBUTE";
      case ErrorCode.USER_ALREADY_EXIST:
        return "MESSAGE_TEXTS.ERROR_MSG.USERNAME_ALREADY_EXIST";
      case ErrorCode.EDIT_COMPO_CLASS_WITHOUT_PERMISSION:
        return "MESSAGE_TEXTS.ERROR_MSG.EDIT_COMPO_CLASS";
      case ErrorCode.ORG_EXIST:
        return "MESSAGE_TEXTS.ERROR_MSG.ORG_ALREADY_EXIST";
      case ErrorCode.PERMISSION_FAILURE:
        return "MESSAGE_TEXTS.ERROR_MSG.ACCESS_DENIED";
      case ErrorCode.MISSING_ADDRESS_ON_PRIMARY_CONTACT:
        return "MESSAGE_TEXTS.ERROR_MSG.MISSING_ADDRESS_FOR_PRIMARY_KONTAKT";
      case ErrorCode.MISSING_PRIMARY_CLIENT_CONTACT:
        return "MESSAGE_TEXTS.ERROR_MSG.MISSING_PRIMARY_CLIENT_CONTACT";
      case ErrorCode.MISSING_PRIMARY_SP_CONTACT:
        return "MESSAGE_TEXTS.ERROR_MSG.MISSING_PRIMARY_SP_CONTACT";
      case ErrorCode.CONTACT_DUPLICATED:
        return "MESSAGE_TEXTS.ERROR_MSG.DUPLICATED_CONTACT_NAME";
      case ErrorCode.DELETE_NOT_ALLOWED:
        return "MESSAGE_TEXTS.ERROR_MSG.DELETE_NOT_ALLOWED";
      case ErrorCode.INVALID_TRIGGER_DATA:
        return "MESSAGE_TEXTS.ERROR_MSG.INVALID_TRIGGER_DATA";
      case ErrorCode.REQUIRED_DATA_NOT_PROVIDED:
        return "MESSAGE_TEXTS.ERROR_MSG.REQUIRED_DATA_NOT_PROVIDED";
      case ErrorCode.INVALID_STATUS_FOR_ORDER:
        return "MESSAGE_TEXTS.ERROR_MSG.INVALID_STATUS_FOR_ORDER";
      case ErrorCode.UPDATE_CLASS_TYPE_NOT_ALLOWED:
        return "MESSAGE_TEXTS.ERROR_MSG.UPDATE_CLASS_TYPE_NOT_ALLOWED";
      case ErrorCode.OBJECT_ELIMINATED:
        return "MESSAGE_TEXTS.ERROR_MSG.OBJECT_ELIMINATED";
      case ErrorCode.DELETE_DOC_AS_NON_OWNER_OF_SHARED_CLASS:
        return "MESSAGE_TEXTS.ERROR_MSG.DELETE_DOC_AS_NON_OWNER_OF_SHARED_CLASS";
      case ErrorCode.ACTIVE_CHILDREN_EXIST:
        return "MESSAGE_TEXTS.ERROR_MSG.ACTIVE_CHILDREN_EXIST";
      case ErrorCode.ELIMINATED_PARENTS_EXIST:
        return "MESSAGE_TEXTS.ERROR_MSG.ELIMINATED_PARENTS_EXIST";
      case ErrorCode.ORG_ITS_OWN_PARENT:
        return "MESSAGE_TEXTS.ERROR_MSG.ORG_ITS_OWN_PARENT";
      case ErrorCode.EMPTY_NAME:
        return "MESSAGE_TEXTS.ERROR_MSG.EMPTY_NAME";
      case ErrorCode.ORG_CHILD_AS_PARENT:
        return "MESSAGE_TEXTS.ERROR_MSG.ORG_CHILD_AS_PARENT";
      case ErrorCode.COMPONENT_NOT_IN_SYSTEM_CLASS:
        return "MESSAGE_TEXTS.ERROR_MSG.COMPONENT_NOT_IN_SYSTEM_CLASS";
      case ErrorCode.UPDATE_EXPIRED_JOB_TEMPLATE:
        return "MESSAGE_TEXTS.ERROR_MSG.UPDATE_EXPIRED_JOB_TEMPLATE";
      case ErrorCode.COUNTER_WRONG_VALUE_DIRECTION_ASC:
        return "MESSAGE_TEXTS.ERROR_MSG.COUNTER_WRONG_VALUE_DIRECTION_ASC";
      case ErrorCode.COUNTER_WRONG_VALUE_DIRECTION_DESC:
        return "MESSAGE_TEXTS.ERROR_MSG.COUNTER_WRONG_VALUE_DIRECTION_DESC";
      case ErrorCode.DELETE_VALUE_OF_COMP_ATTR:
        return "MESSAGE_TEXTS.ERROR_MSG.DELETE_VALUE_OF_COMP_ATTR";
      case ErrorCode.SET_CAN_CONTAIN_COMPONENT_FLAG_AS_NON_SUPERUSER:
        return "MESSAGE_TEXTS.ERROR_MSG.SET_CAN_CONTAIN_COMPONENT_FLAG_AS_NON_SUPERUSER";
      case ErrorCode.UPDATE_CAN_CONTAIN_COMPONENT_WHILE_HAVING_COMPONENTS:
        return "MESSAGE_TEXTS.ERROR_MSG.UPDATE_CAN_CONTAIN_COMPONENT_WHILE_HAVING_COMPONENTS";
      case ErrorCode.SET_CAN_CONTAIN_COMPONENT_AS_NON_SYSTEM_CLASS:
        return "MESSAGE_TEXTS.ERROR_MSG.SET_CAN_CONTAIN_COMPONENT_AS_NON_SYSTEM_CLASS";
      case ErrorCode.CREATE_COMPONENT_OF_A_CANNOT_CONTAIN_COMPONENT_CLASS:
        return "MESSAGE_TEXTS.ERROR_MSG.CREATE_COMPONENT_OF_A_CANNOT_CONTAIN_COMPONENT_CLASS";
      case ErrorCode.CLASS_DELETE_WITH_CHECKLIST_TEMPLATE:
        return "MESSAGE_TEXTS.ERROR_MSG.CLASS_DELETE_WITH_CHECKLIST_TEMPLATE";
      case ErrorCode.CHECKLIST_VERSIONED_MODIFICATION:
        return "MESSAGE_TEXTS.ERROR_MSG.CHECKLIST_VERSIONED_MODIFICATION";
      case ErrorCode.CHECKLIST_VALIDATION_JOB_TO_FINISHED:
        return "MESSAGE_TEXTS.ERROR_MSG.CHECKLIST_VALIDATION_JOB_TO_FINISHED";
      case ErrorCode.CHECKLIST_CANNOT_BE_MADE_PUBLIC:
        return "MESSAGE_TEXTS.ERROR_MSG.CHECKLIST_CANNOT_BE_MADE_PUBLIC";
      case ErrorCode.LOCATION_PARENT_VALIDATION:
        return "MESSAGE_TEXTS.ERROR_MSG.LOCATION_PARENT_VALIDATION";
      case ErrorCode.PRODUCER_WAS_NOT_SET:
        return "MESSAGE_TEXTS.ERROR_MSG.PRODUCER_WAS_NOT_SET";
      case ErrorCode.NOT_ALLOWED_CHANGE_OF_PRODUCER_IN_COMP:
        return "MESSAGE_TEXTS.ERROR_MSG.NOT_ALLOWED_CHANGE_OF_PRODUCER_IN_COMP";
      case ErrorCode.COMPONENT_CANNOT_BE_CHILD_OF_ITS_ANCESTOR:
        return "MESSAGE_TEXTS.ERROR_MSG.COMPONENT_CANNOT_BE_CHILD_OF_ITS_ANCESTOR";
      case ErrorCode.HEAVY_CHANGE_IN_ACTION:
        return "MESSAGE_TEXTS.ERROR_MSG.HEAVY_CHANGE_IN_ACTION";
      case ErrorCode.BULK_CHILD_PARENT_DIFFERENT_OBJECT_STATE:
        return "MESSAGE_TEXTS.ERROR_MSG.BULK_CHILD_PARENT_DIFFERENT_OBJECT_STATE";
      case ErrorCode.PARENT_CHILD_INVALID_OBJECT_STATE:
        return "MESSAGE_TEXTS.ERROR_MSG.PARENT_CHILD_INVALID_OBJECT_STATE";
      case ErrorCode.DIFFERENT_MODULE_ORG_ID:
        return "MESSAGE_TEXTS.ERROR_MSG.DIFFERENT_MODULE_ORG_ID";
      case ErrorCode.VERSIONED_CHECKLIST_EXISTS:
        return "MESSAGE_TEXTS.ERROR_MSG.VERSIONED_CHECKLIST_EXISTS";
      case ErrorCode.MODULE_DELETE_WITH_CHECKLIST_TEMPLATE:
        return "MESSAGE_TEXTS.ERROR_MSG.MODULE_DELETE_WITH_CHECKLIST_TEMPLATE";
      case ErrorCode.COMPONENT_GROUP_NOT_FOUND:
        return "MESSAGE_TEXTS.ERROR_MSG.FAVORITE_NOT_FOUND";
      case ErrorCode.COMPONENT_IS_STRONG_BOUND:
        return "MESSAGE_TEXTS.ERROR_MSG.COMPONENT_IS_STRONG_BOUND";
      case ErrorCode.ATTRIBUTE_IDENTIFIER_IN_GLOBAL_MODULE:
        return "MESSAGE_TEXTS.ERROR_MSG.ATTRIBUTE_IDENTIFIER_IN_GLOBAL_MODULE";
      case ErrorCode.CANNOT_REMOVE_CLASS_WITH_OBJECTS_FROM_PRIO_CLASSES:
        return "MESSAGE_TEXTS.ERROR_MSG.CANNOT_REMOVE_CLASS_WITH_OBJECTS_FROM_PRIO_CLASSES";
      case ErrorCode.CAN_NOT_DELETE_COLLECTION:
        return "MESSAGE_TEXTS.ERROR_MSG.CAN_NOT_DELETE_COLLECTION";
      case ErrorCode.MULTI_OBJECT_COUNT_TOO_HIGH:
        return "MESSAGE_TEXTS.ERROR_MSG.MULTI_OBJECT_COUNT_TOO_HIGH";
      case ErrorCode.MOVED_MULTI_OBJECT_COUNT_TOO_HIGH:
        return "MESSAGE_TEXTS.ERROR_MSG.MOVED_MULTI_OBJECT_COUNT_TOO_HIGH";
      case ErrorCode.USER_AREA_NOT_EDITABLE:
        return "DESIGN_B.MESSAGE_TEXTS.ERROR.USER_AREA.SAVE_FAILED.USER_AREA_NOT_EDITABLE";
      case ErrorCode.CANNOT_SET_MAPPING_TO_EXPIRED:
        return "DESIGN_B.MESSAGE_TEXTS.ERROR.USER_RIGHTS_ROLE_USER_MAPPING.CANNOT_SET_MAPPING_TO_EXPIRED_DEFAULT_CONTRACT_ADMIN";
      case ErrorCode.CANNOT_DELETE_DEFAULT_ADMIN:
        return "DESIGN_B.USER.DETAIL.DELETE.CANNOT_DELETE_DEFAULT_ADMIN";
      case ErrorCode.USER_CANNOT_DELETE_ITSELF:
        return "DESIGN_B.USER.DETAIL.DELETE.CANNOT_DELETE_OWN_USER";
      case ErrorCode.AI_CREDIT_SCORE_FOR_USER_TO_LOW:
        return "DESIGN_B.MESSAGE_TEXTS.ERROR.AI_CREDIT_SCORE_FOR_USER_TO_LOW";
      case ErrorCode.AI_NO_CREDIT_SCORE_FOR_USER:
        return "DESIGN_B.MESSAGE_TEXTS.ERROR.AI_NO_CREDIT_SCORE_FOR_USER";
      case ErrorCode.JOB_ROUTINE_OR_TRIGGER_MODIFIED:
        return "MESSAGE_TEXTS.ERROR_MSG.JOB_ROUTINE_OR_TRIGGER_MODIFIED";
      case ErrorCode.COLLECTION_OBJECT_WITH_LENT_OR_BORROWED_MULTI_OBJECTS:
        return "MESSAGE_TEXTS.ERROR_MSG.COLLECTION_HAS_LENT_OR_BORROWED_MULTI_OBJECTS";
      case ErrorCode.COLLECTION_OBJECT_AS_A_CHILD_WITH_LENT_OR_BORROWED_MULTI_OBJECTS:
        return "MESSAGE_TEXTS.ERROR_MSG.COLLECTION_AS_A_CHILD_HAS_LENT_OR_BORROWED_MULTI_OBJECTS";
      case ErrorCode.ACTIVE_CLIENT_MAPPING_OR_USED_SERVICE_PROVIDER_DATA:
        return "MESSAGE_TEXTS.ERROR_MSG.ACTIVE_CLIENT_MAPPING_OR_USED_SERVICE_PROVIDER_DATA";
      case ErrorCode.MISSING_DOCUMENT_GROUP_ACCESS:
        return "MESSAGE_TEXTS.ERROR_MSG.MISSING_DOCUMENT_GROUP_ACCESS";
      case ErrorCode.SERVICE_PROVIDER_DID_NOT_ANSWER_IN_TIME:
        return "MESSAGE_TEXTS.ERROR_MSG.SERVICE_PROVIDER_DID_NOT_ANSWER_IN_TIME";
      case ErrorCode.SERVICE_PROVIDER_CANNOT_GET_INITIAL_IDS_FOR_BOTH_JOBS_AND_OBJECT_IDS:
        return "MESSAGE_TEXTS.ERROR_MSG.SERVICE_PROVIDER_CANNOT_GET_INITIAL_IDS_FOR_BOTH_JOBS_AND_OBJECT_IDS";
      case ErrorCode.NO_INITIAL_IDS_PROVIDED_TO_SERVICE_PROVIDER:
        return "MESSAGE_TEXTS.ERROR_MSG.NO_INITIAL_IDS_PROVIDED_TO_SERVICE_PROVIDER";
      case ErrorCode.JOBS_WITH_MULTIPLE_OWNERS_CANNOT_BE_IN_A_SINGLE_JOB_COORDINATION:
        return "MESSAGE_TEXTS.ERROR_MSG.JOBS_WITH_MULTIPLE_OWNERS_CANNOT_BE_IN_A_SINGLE_JOB_COORDINATION";
      case ErrorCode.OBJECTS_WITH_MULTIPLE_OWNERS_CANNOT_BE_IN_A_SINGLE_JOB_COORDINATION:
        return "MESSAGE_TEXTS.ERROR_MSG.OBJECTS_WITH_MULTIPLE_OWNERS_CANNOT_BE_IN_A_SINGLE_JOB_COORDINATION";
      case ErrorCode.MISING_USER_ID:
        return "MESSAGE_TEXTS.ERROR_MSG.MISING_USER_ID";
      case ErrorCode.NO_ACCESS_TO_JOBS:
        return "MESSAGE_TEXTS.ERROR_MSG.NO_ACCESS_TO_JOBS";
      case ErrorCode.NO_ACCESS_TO_OBJECTS:
        return "MESSAGE_TEXTS.ERROR_MSG.NO_ACCESS_TO_OBJECTS";
      default:
        return "MESSAGE_TEXTS.ERROR_MSG.UNKNOWN_ERROR";
    }
  }
}
